import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-android-redirect',
    template: `<p>Redirecting to Google Play Store...</p>`
})
export class AndroidRedirectComponent implements OnInit {
    ngOnInit() {
        window.location.href = 'intent://details?id=com.kripalunidhi#Intent;scheme=market;package=com.android.vending;end';
    }
}
